// extracted by mini-css-extract-plugin
export default {"main":"et_main__VDOn-","h2":"et_h2__J6n-U","h3":"et_h3__-C7vD","description":"et_description__m8u2R","full_img":"et_full_img__7BOII","ul":"et_ul__VCLJc"};